
<div class="flip-card cardshown " >
    <div class="flip-card-inner cardshown" [ngClass]="{'newClass':renewForm==true}" >
      <div class="flip-card-front cardshown">
        <div *ngIf="!dataloading" class="card  " style="height: 100%;" >
            <div class="card-header bg-transparent border-success  ml-3 d-flex justify-content-between">
                <h4 class="mt-3"> Hello, {{userName}}.</h4><img src="../../../assets/images/logo.jpeg" style="width: 3rem;height: 3rem;margin-right:1rem ;margin-top: 5px;">
            </div>
            <span style="height: 1px;background-color: rgb(213, 206, 206);"></span>
        
            <div class="card-body  m-3" style="color: red;">
                <h5 class="card-title">License Expired...</h5>
                <h6 class="card-text">Hello {{userName}} your license expired please renewal your license!</h6>
            </div>
            <span style="height: 1px;background-color: rgb(213, 206, 206);"></span>
            <div class="card-footer bg-transparent border-success text-right m-2"><button class="btn btn-outline-primary" (click)="openForm()"
                  >Renewal License</button></div>
        </div>
        <div *ngIf="dataloading" class="card cardshown mb-3" style="width: 30rem;height: 100%;">
            <div id="load">
          <div>G</div>
          <div>N</div>
          <div>I</div>
          <div>D</div>
          <div>A</div>
          <div>O</div>
          <div>L</div>
        </div>
        </div>
      </div>
      <div class="flip-card-back">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Renewal License</h1>
                <button type="button" class="btn-close"  (click)="goBack()" aria-label="Close"></button>
            </div>
            <form class="modal-body">
                <div class="mb-3">
                    <label class="text-black ">Renewal Code</label>
                    <input type="email" class="form-control" id="renewalCode" aria-describedby="emailHelp">
                    <div id="emailHelp" class="form-text">Renewal is Valid upto 3 months only.</div>
                  </div>
                
                </form>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="goBack()">Close</button>
                <button type="button" class="btn btn-primary" (click)="onsubmit()"
                    >Submit</button>
            </div>
        </div>
      </div>
    </div>
  </div>
  